import { FC, Suspense, lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_uLearn/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';
import { getCSSVariableValue } from '../../_uLearn/assets/ts/_utils';
import { WithChildren } from '../../_uLearn/helpers';
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper';
import CMSPage from '../modules/cms-pages/index';
import AllActivity from '../modules/activity-configuration/index';
import AllSchools from '../modules/schools/index';
import Teachers from '../modules/teacher/index';
import Students from '../modules/students/index'
import Vendors from '../modules/vendors/index';
import AppSettings from '../modules/app-settings';
const PrivateRoutes = () => {
  const MasterPage = lazy(() => import('../modules/master/index'));
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        {/* Pages */}
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="builder" element={<BuilderPageWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        <Route
          path="all-activity/*"
          element={
            <SuspensedView>
              <AllActivity />
            </SuspensedView>
          }
        />
        <Route
          path="all-schools/*"
          element={
            <SuspensedView>
              <AllSchools />
            </SuspensedView>
          }
        />
        <Route
          path="teachers/*"
          element={
            <SuspensedView>
              <Teachers />
            </SuspensedView>
          }
        />
        <Route
          path="students/*"
          element={
            <SuspensedView>
              <Students />
            </SuspensedView>
          }
        />
        <Route
          path="vendors/*"
          element={
            <SuspensedView>
              <Vendors />
            </SuspensedView>
          }
        />
        <Route
          path="cms-pages/*"
          element={
            <SuspensedView>
              <CMSPage />
            </SuspensedView>
          }
        />
        {/* Lazy Modules */}
        <Route
          path="master/*"
          element={
            <SuspensedView>
              <MasterPage />
            </SuspensedView>
          }
        />
        <Route
          path="appSettings/*"
          element={
            <SuspensedView>
              <AppSettings />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );;
};
const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary');
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};
export { PrivateRoutes };
